{
  "iframeWaitingMessage": "Gracias por su paciencia. Espere un poco más…",
  "otherOrganizations": "Otras organizaciones",
  "solutionIframe": "Contenido principal",
  "unloadPromptMessage": "¿Está seguro?"
}
